// Port of api/fuel/app/classes/controller/api/monty/listing/item/comment.php
import DB from 'offline/db'
import ListingComment from 'offline/model/listing/comment'
import {
	commentPayload,
	currentEdition,
	currentUserId,
	loadListingEdition,
	loadOwnedListing,
	parseGameIndex,
	persist,
	unauthorised
} from '../shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)
	var edition = null
	var gameId = parseInt(params.game, 10) || 0
	var text = String(params.comment || '').trim()
	var comment = null

	if (!userId) return unauthorised()
	if (!listing) return Promise.reject({ error: 120, offline: true })

	edition = loadListingEdition(listing, params.edition) || currentEdition(listing)
	if (!edition) return Promise.reject({ error: 120, offline: true })
	if (parseGameIndex(edition.get_index_games()).indexOf(gameId) === -1) return unauthorised()

	comment = ListingComment.record({
		where: [
			['list_id', '=', listing.get_id()],
			['list_edition_id', '=', edition.get_id()],
			['game_id', '=', gameId]
		]
	})

	if (!text && !comment) return unauthorised()

	if (text) {
		if (comment) {
			DB.run('UPDATE list_comment SET list_comment_text = ?, list_comment_date = ? WHERE list_comment_id = ?', [
				text,
				Math.floor(Date.now() / 1000),
				comment.get_id()
			])
		} else {
			DB.run('INSERT INTO list_comment (list_id, list_edition_id, game_id, list_comment_date, list_comment_text) VALUES (?, ?, ?, ?, ?)', [
				listing.get_id(),
				edition.get_id(),
				gameId,
				Math.floor(Date.now() / 1000),
				text
			])
		}

		return persist(commentPayload(text))
	}

	DB.run('DELETE FROM list_comment WHERE list_comment_id = ?', [comment.get_id()])
	return persist({})
}
